import { Brain, Layers, Lock } from "lucide-react";

const reasons = [
  {
    icon: Brain,
    title: "Think the way your brain does",
    body: "Ideas don't arrive in a straight line. Spread notes, sketches, and links across an infinite canvas and see how everything connects — at a glance.",
  },
  {
    icon: Layers,
    title: "One canvas for everything",
    body: "Meeting transcripts, web clips, freehand drawings, and typed notes live side by side. No more scattering your thinking across five different apps.",
  },
  {
    icon: Lock,
    title: "Private by default",
    body: "Local-first with optional cloud sync, and you can switch on end-to-end encryption per folder so not even OmniCanvas can read those notes.",
  },
];

export function Testimonials() {
  return (
    <section id="why" className="py-24 md:py-32 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-4">
            Why it&apos;s different
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            We&apos;re a new, independent app in open beta. Here&apos;s what makes
            OmniCanvas different from the notes app you&apos;re using now.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((r, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm"
            >
              <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-indigo-50 text-indigo-600 mb-5">
                <r.icon size={22} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">
                {r.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">{r.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
